// Pre-hide product countdown timers if after 8PM (prevents flash on load)
(function() {
  const currentHour = new Date().getHours();
  if (currentHour >= 20) {
    // Add style to hide product countdown timers immediately
    const style = document.createElement('style');
    style.id = 'countdown-prehide';
    style.textContent = '.product__countdown-timer { display: none !important; }';
    document.head.appendChild(style);
    
    // Remove the style after timers are initialized
    window.addEventListener('load', () => {
      setTimeout(() => {
        const styleEl = document.getElementById('countdown-prehide');
        if (styleEl) styleEl.remove();
      }, 200);
    });
  }
})();

// Countdown Timer Module
(function() {
  'use strict';
  
  // Store all active timers to prevent duplicates
  const activeTimers = new WeakMap();
  
  class CountdownTimer {
    constructor(element) {
      // Prevent duplicate initialization
      if (activeTimers.has(element)) {
        return activeTimers.get(element);
      }
      
      this.element = element;
      this.timeElement = element.querySelector('.countdown-timer__time, .sale-countdown__time');
      this.interval = null;
      this.destroyed = false;
      
      // Check if this is a product countdown timer (same-day dispatch)
      this.isProductCountdown = element.classList.contains('product__countdown-timer') ||
                                element.closest('.product__countdown-timer') !== null;
      
      // Check if this is a sale countdown
      this.isSaleCountdown = element.classList.contains('sale-countdown') || 
                             element.closest('.sale-countdown') !== null;
      
      // Read settings from data attributes for sale countdown
      if (this.isSaleCountdown) {
        this.countdownActive = element.dataset.countdownActive === 'true';
        this.countdown24h = element.dataset.countdown24h === 'true';
        this.countdownEndDate = element.dataset.countdownEnd;
        
        // If countdown is disabled, don't initialize timer
        if (!this.countdownActive) {
          if (this.timeElement) {
            this.timeElement.style.display = 'none';
          }
          return;
        }
      }
      
      // Debug logging (remove in production)
      if (!this.timeElement) {
        console.warn('CountdownTimer: No time element found in', element);
        return;
      }
      
      // Store instance to prevent duplicates
      activeTimers.set(element, this);
      
      if (this.timeElement) {
        this.init();
      }
    }
    
    init() {
      this.calculateTimeRemaining();
      
      // Check if we should hide the timer
      if (this.shouldHideTimer()) {
        this.element.style.display = 'none';
        // Still start the timer so it can unhide itself when appropriate
      } else {
        this.element.style.display = '';
      }
      
      this.updateDisplay();
      this.start();
      
      // Add cleanup on element removal
      this.observer = new MutationObserver(() => {
        if (!document.contains(this.element)) {
          this.destroy();
        }
      });
      
      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
    
    shouldHideTimer() {
      // Product countdown logic - hide between 8PM and midnight
      if (this.isProductCountdown && !this.isSaleCountdown) {
        const now = new Date();
        const currentHour = now.getHours();
        
        // Hide between 8PM (20:00) and midnight (23:59)
        return currentHour >= 20;
      }
      
      return false;
    }
    
    calculateTimeRemaining() {
      const now = new Date();
      let targetTime;
      
      if (this.isSaleCountdown) {
        if (this.countdownEndDate && this.countdownEndDate.trim() !== '') {
          // Custom date countdown
          // Parse the date string (format: YYYY-MM-DD HH:MM)
          const dateStr = this.countdownEndDate.trim();
          
          // Try to parse the date
          try {
            // Handle various formats
            let parsedDate;
            
            if (dateStr.includes('T')) {
              // ISO format: 2025-11-29T23:59
              parsedDate = new Date(dateStr);
            } else if (dateStr.match(/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}/)) {
              // Format: 2025-11-29 23:59
              parsedDate = new Date(dateStr.replace(' ', 'T'));
            } else {
              // Try default parsing
              parsedDate = new Date(dateStr);
            }
            
            if (!isNaN(parsedDate.getTime())) {
              targetTime = parsedDate;
              this.totalSeconds = Math.floor((targetTime - now) / 1000);
              
              // If date has passed, set to 0
              if (this.totalSeconds < 0) {
                this.totalSeconds = 0;
              }
            } else {
              // Invalid date, fallback to 24h
              console.warn('Invalid date format, using 24h loop');
              this.countdown24h = true;
            }
          } catch (e) {
            console.warn('Error parsing date, using 24h loop:', e);
            this.countdown24h = true;
          }
        }
        
        if (this.countdown24h || !this.countdownEndDate || this.countdownEndDate.trim() === '') {
          // 24 hour loop - count to midnight and reset
          targetTime = new Date();
          targetTime.setDate(targetTime.getDate() + 1);
          targetTime.setHours(0, 0, 0, 0);
          
          this.totalSeconds = Math.floor((targetTime - now) / 1000);
        }
      } else if (this.isProductCountdown) {
        // Calculate time until 8PM today
        targetTime = new Date();
        targetTime.setHours(20, 0, 0, 0); // 8PM = 20:00
        
        // If it's already past 8PM, set target to 8PM tomorrow
        if (now >= targetTime) {
          targetTime.setDate(targetTime.getDate() + 1);
        }
        
        this.totalSeconds = Math.floor((targetTime - now) / 1000);
      } else {
        // Calculate time until midnight (original behavior)
        targetTime = new Date();
        targetTime.setDate(targetTime.getDate() + 1);
        targetTime.setHours(0, 0, 0, 0);
        
        this.totalSeconds = Math.floor((targetTime - now) / 1000);
      }
      
      // Safety check
      if (this.totalSeconds < 0) {
        this.totalSeconds = 0;
      }
    }
    
    start() {
      // Clear any existing interval
      if (this.interval) {
        clearInterval(this.interval);
      }
      
      this.interval = setInterval(() => {
        if (this.destroyed) {
          this.stop();
          return;
        }
        
        this.totalSeconds--;
        
        // Reset when countdown reaches zero
        if (this.totalSeconds <= 0) {
          this.calculateTimeRemaining();
        }
        
        // Check if timer should be hidden (product countdown between 8PM-midnight)
        if (this.shouldHideTimer()) {
          this.element.style.display = 'none';
        } else {
          this.element.style.display = '';
          this.updateDisplay();
        }
      }, 1000);
    }
    
    stop() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }
    
    destroy() {
      this.destroyed = true;
      this.stop();
      
      if (this.observer) {
        this.observer.disconnect();
      }
      
      // Remove from active timers
      if (this.element && activeTimers.has(this.element)) {
        activeTimers.delete(this.element);
      }
    }
    
    updateDisplay() {
      if (!this.timeElement || this.destroyed || !document.contains(this.timeElement)) {
        return;
      }
      
      const days = Math.floor(this.totalSeconds / (24 * 3600));
      const hours = Math.floor((this.totalSeconds % (24 * 3600)) / 3600);
      const minutes = Math.floor((this.totalSeconds % 3600) / 60);
      const seconds = this.totalSeconds % 60;
      
      // Format based on parent class - check multiple levels up
      let timeString;
      const isSaleCountdown = this.element.classList.contains('sale-countdown') || 
                              this.element.closest('.sale-countdown') !== null ||
                              this.timeElement.classList.contains('sale-countdown__time');
      
      if (isSaleCountdown) {
        // Format: 00D : 00U : 00M : 00S (days), 00 : 00 : 00 (hours), or 00 : 00 (minutes)
        if (days > 0) {
          timeString = `${days.toString().padStart(2, '0')}D : ${hours.toString().padStart(2, '0')}U : ${minutes.toString().padStart(2, '0')}M : ${seconds.toString().padStart(2, '0')}S`;
        } else if (hours > 0) {
          timeString = `${hours.toString().padStart(2, '0')} : ${minutes.toString().padStart(2, '0')} : ${seconds.toString().padStart(2, '0')}`;
        } else {
          timeString = `${minutes.toString().padStart(2, '0')} : ${seconds.toString().padStart(2, '0')}`;
        }
      } else {
        // Format: HH:MM:SS for regular countdown
        timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      }
      
      this.timeElement.textContent = timeString;
    }
  }
  
  // Initialize function
  function initializeCountdownTimers(container = document) {
    // Find all countdown elements within the container
    // Using separate queries for better compatibility
    const countdownTimers = container.querySelectorAll('.countdown-timer');
    const saleCountdowns = container.querySelectorAll('.sale-countdown');
    const productCountdowns = container.querySelectorAll('.product__countdown-timer');
    
    // Combine all NodeLists
    const allTimers = [...countdownTimers, ...saleCountdowns, ...productCountdowns];
    
    allTimers.forEach(element => {
      // Check if element has the required time element
      const timeElement = element.querySelector('.countdown-timer__time, .sale-countdown__time');
      
      // Only initialize if time element exists and not already initialized
      if (timeElement && !activeTimers.has(element)) {
        new CountdownTimer(element);
      }
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeCountdownTimers();
    });
  } else {
    // DOM already loaded
    setTimeout(() => initializeCountdownTimers(), 0);
  }
  
  // Additional initialization with slight delay to catch late-rendering elements
  window.addEventListener('load', () => {
    setTimeout(() => initializeCountdownTimers(), 100);
  });
  
  // Handle dynamic content (AJAX, Shopify theme editor, etc.)
  if (typeof Shopify !== 'undefined') {
    // Theme editor support
    document.addEventListener('shopify:section:load', (event) => {
      initializeCountdownTimers(event.target);
    });
    
    document.addEventListener('shopify:section:unload', (event) => {
      // Clean up timers in unloaded sections
      const elements = event.target.querySelectorAll('.countdown-timer, .sale-countdown, .product__countdown-timer');
      elements.forEach(element => {
        if (activeTimers.has(element)) {
          const timer = activeTimers.get(element);
          timer.destroy();
        }
      });
    });
    
    // Handle variant changes
    document.addEventListener('variant:change', () => {
      setTimeout(() => initializeCountdownTimers(), 100);
    });
  }
  
  // Expose to global scope if needed for manual initialization
  window.CountdownTimer = {
    init: initializeCountdownTimers,
    getInstance: (element) => activeTimers.get(element)
  };
  
})();
